import { Box } from "@mui/material";
import { CommitmentRequirementDetails } from "../../../../../../types";
import CommitmentRequirement from "./CommitmentRequirement";
import { DossierInfosType } from "../../../Dossier";

type CommitmentRequirementsListProps = {
    commitmentRequirements: CommitmentRequirementDetails[];
    updateCommitementDetails: Function;
    dossierInfos: DossierInfosType;
};

export default function CommitmentRequirementsList({
    commitmentRequirements,
    updateCommitementDetails,
    dossierInfos,
}: CommitmentRequirementsListProps) {
    const commitmentRequirementsSorted = commitmentRequirements.sort(
        (cPrev, cNext) => (cPrev.position || 0) - (cNext.position || 0)
    );
    return (
        <Box
            sx={{
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "4rem",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2.5rem",
                    width: "100%",
                }}
            >
                {commitmentRequirementsSorted.map((commitmentRequirement) => {
                    return (
                        <CommitmentRequirement
                            key={commitmentRequirement.id}
                            customkey={commitmentRequirement.id}
                            commitmentRequirement={commitmentRequirement}
                            updateCommitementDetails={updateCommitementDetails}
                            dossierInfos={dossierInfos}
                        />
                    );
                })}
            </Box>
        </Box>
    );
}
